<div class="details-layout-container">
  <div [style.margin]="margin" class="details-layout-title">
    <div class="d-flex w-100">
      {{ title }}
      <ng-content select='[titleSuffix]'></ng-content>
    </div>
    <ng-content select='[titleDescription]'></ng-content>
  </div>
  <div class="details-layout-body">

    <div *ngIf="showNoData" class="details-layout-card">
      {{ noDataMessage }}
      <ng-content select='[noDataSuffix]'></ng-content>
    </div>

    <ng-content select='[body]'></ng-content>
  </div>
  <div *ngIf="showWarning && warningMessage" class="details-layout-notification">
    <ngb-alert [dismissible]="false" [type]="'warning'" class="warning-message">
      <div class="d-flex align-items-center">
        <pt-icon [key]='IconWarning' [size]="18" class="d-flex me-1"></pt-icon>
        <div class="d-inline-flex">{{ warningMessage }}</div>
      </div>
    </ngb-alert>
  </div>

  <div *ngIf="showInfo && infoMessage" class="details-layout-notification">
    <ngb-alert [dismissible]="false" [type]="'info'" class="info-message">
      <div class="d-flex align-items-center">
        <pt-icon [key]='IconWarning' [size]="18" class="d-flex me-1"></pt-icon>
        <div class="d-inline-flex">{{ infoMessage }}</div>
      </div>
    </ngb-alert>
  </div>
</div>
